<template>
  <div row :class="ui.colorNavigationBar">
    <v-layout row class="mr-3">
      <v-spacer/>
      <div v-if="this.userOK">
        <v-btn icon small :color="ui.bkgdColor" dark
        v-if="
        this.getDocumentLogUserAttentionCounter !== null &&
        this.getDocumentLogUserAttentionCounter !== undefined">
          <v-badge right>
            <v-icon :color="ui.btnColor">
              notifications_active
            </v-icon>
            <span :class="ui.textSubheadingBold"
            v-if="this.getUser.pref.select.cauth !== null">
            {{this.getDocumentLogUserAttentionCounter}}
            </span>
          </v-badge>
        </v-btn>
      </div>
      <div v-if="this.userOK">
        <v-btn icon small :color="ui.bkgdColor" dark
        v-if="
        this.getDocumentLogUserUnreadCounter !== null &&
        this.getDocumentLogUserUnreadCounter !== undefined">
          <v-badge right>
            <v-icon :color="ui.btnColor">
              mark_email_unread
            </v-icon>
            <span :class="ui.textSubheadingBold"
            v-if="this.getUser.pref.select.cauth !== null">
            {{this.getDocumentLogUserUnreadCounter}}
            </span>
          </v-badge>
        </v-btn>
      </div>
    </v-layout>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";

export default {
  mixins: [apptheme, adminFunctions],
  computed: {
    ...mapGetters([
      "getUser",
      "getDocumentLogUserUnreadCounter",
      "getDocumentLogUserAttentionCounter"
    ])
  }
};
</script>
